import React from 'react';
import QRCode from './QRCode';
import BarCode from './BarCode';
export var CodeType;
(function (CodeType) {
    CodeType["QR"] = "qr";
    CodeType["BAR"] = "bar";
})(CodeType || (CodeType = {}));
const QRBarCode = function QRBarCode(props) {
    const { type = CodeType.QR, ...rest } = props;
    if (type === CodeType.QR) {
        return React.createElement(QRCode, Object.assign({}, rest));
    }
    return React.createElement(BarCode, Object.assign({}, rest));
};
export default QRBarCode;
